import React from 'react';
import { Divider, Grid } from '@mui/material';

import { MultiValueBooleanInput } from '../../multi-value-controls/MultiValueBooleanInput';
import { MultiValueNumberInput } from '../../multi-value-controls/MultiValueNumberInput';
import { LoadSettingsControlProps } from '../LoadSettingsControls';

export function RoofTCLiveSettings({ disabled, loadSettingsArray, setLoadSettingsValues }: LoadSettingsControlProps) {
  return (
    <>
      <Grid size={6}>
        <MultiValueNumberInput
          disabled={disabled}
          values={loadSettingsArray.map((loadSettings) => loadSettings.roofTopChordLiveLoad)}
          submit={(roofTopChordLiveLoad) => setLoadSettingsValues({ roofTopChordLiveLoad })}
          label="TC Live Load"
          unit="psf"
        />
      </Grid>

      <Grid size={6}>
        <MultiValueBooleanInput
          disabled={disabled}
          values={loadSettingsArray.map((loadSettings) => loadSettings.considerUnbalancedRoofLiveLoad)}
          onChange={(considerUnbalancedRoofLiveLoad) => setLoadSettingsValues({ considerUnbalancedRoofLiveLoad })}
          label="Consider Unbalanced"
        />
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>
    </>
  );
}
